<app-page>
  <app-page-title
    [title]="'TENANTS.CREATE-TENANT' | translate"
  ></app-page-title>

  <app-admin-login
    *ngIf="!isAuthenticated && isLoaded"
    (loginSuccess)="onLoginSuccess()"
  ></app-admin-login>

  <div *ngIf="isAuthenticated || !isLoaded">
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="avatar-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="avatar-img"
              [src]="imagePreview"
              *ngIf="imagePreview"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!imagePreview"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useForm"
            [visible]="false"
            (valueChange)="onImageUploaded($event)"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <dx-form 
          #form
          [formData]="formData"
          labelMode="floating"
          [showColonAfterLabel]="false"
        >
          <dxi-item dataField="tenantName" [isRequired]="true">
            <dxo-label 
              [text]="'COMMON.FIELDS.TENANT-NAME' | translate"
            ></dxo-label>
            <dxi-validation-rule 
              type="required" 
              [message]="'VALIDATIONS.TENANT-NAME-REQUIRED' | translate" 
            />
          </dxi-item>
          <dxi-item
            dataField="tenantDescription"
            editorType="dxTextArea"
            [isRequired]="true"
            cssClass="tenant-description"
          >
            <dxo-label
              [text]="'COMMON.FIELDS.TENANT-DESCRIPTION' | translate"
            ></dxo-label>
            <dxi-validation-rule
              type="required"
              [message]="'VALIDATIONS.TENANT-DESCRIPTION-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>

          <dxi-item itemType="group">
            <dxo-col-count-by-screen
              [xs]="1"
              [sm]="1"
              [md]="1"
              [lg]="2"
            ></dxo-col-count-by-screen>
            <dxi-item dataField="lastName" [isRequired]="true">
              <dxo-label 
                [text]="'COMMON.FIELDS.LAST-NAME' | translate"
              ></dxo-label>
              <dxi-validation-rule 
                type="required" 
                [message]="'VALIDATIONS.LAST-NAME-REQUIRED' | translate" 
              />
            </dxi-item>

            <dxi-item dataField="firstName" [isRequired]="true">
              <dxo-label 
                [text]="'COMMON.FIELDS.FIRST-NAME' | translate"
              ></dxo-label>
              <dxi-validation-rule 
                type="required" 
                [message]="'VALIDATIONS.FIRST-NAME-REQUIRED' | translate" 
              />
            </dxi-item>
          </dxi-item>

          <dxi-item dataField="email" [isRequired]="true">
            <dxo-label 
              [text]="'COMMON.FIELDS.EMAIL' | translate"
            ></dxo-label>
            <dxi-validation-rule 
              type="required" 
              [message]="'VALIDATIONS.EMAIL-REQUIRED' | translate" 
            />
            <dxi-validation-rule 
              type="email" 
              [message]="'VALIDATIONS.EMAIL-INVALID' | translate" 
            />
          </dxi-item>

          <dxi-item>
            <div *dxTemplate class="domains-wrapper">
              <div class="domains-title">
                {{ "COMMON.FIELDS.TENANT-DOMAINS" | translate }}
              </div>
              <div class="w-100">
                <dx-tag-box
                  [items]="formData.domains"
                  [(value)]="formData.domains"
                  [acceptCustomValue]="true"
                  [inputAttr]="{ 'aria-label': 'Domain' }"
                  [openOnFieldClick]="false"
                >
                  <div 
                    *dxTemplate="let tagData of 'tagTemplate'" 
                    class="dx-tag-content"
                  >
                    <span>{{ tagData }}</span>
                    <div class="dx-tag-remove-button"></div>
                  </div>
                </dx-tag-box>
              </div>
            </div>
          </dxi-item>

          <dxi-item
            editorType="dxCheckBox"
            dataField="cloneDataFromSourceTenant"
            [editorOptions]="{
              text: 'COMMON.FIELDS.CLONE-DATE-FROM-SOURCE-TENANT' | translate,
            }"
          >
            <dxo-label [visible]="false"> </dxo-label>
          </dxi-item>
          <dxi-item
            itemType="button"
            [buttonOptions]="{
              text: ('COMMON.CREATE' | translate),
              type: 'default',
              icon: 'check',
              onClick: createTenant,
              useSubmitBehavior: true,
            }"
          ></dxi-item>
        </dx-form>
      </div>
    </div>
  </div>
</app-page>

